<template>
  <header>
        <div class="logoArea">
            <img alt="school logo" :src="schoolLogoFilePath"  class="logo" v-if="showHeader">
            <!-- <p class="schoolname" v-show="showHeader">{{schoolname}}</p> -->
        </div>

        <div class="navArea" v-if="loggedIn">
            <div class="vertFlex">
                
                <div class="horizFlex">
                    <button :class="navButtonClass('openclose')" @click="selectNav('openclose')" v-if="showOpenClose" :disabled="disableTab('Open Close Tab')">
                        Open/Close
                    </button>
                    <button :class="navButtonClass('productgroup')" @click="checkNav('productgroup','Product Group Tab')" :disabled="disableTab('Product Group Tab')">
                        Product Groups 
                    </button>
                    <button :class="navButtonClass('product')" @click="checkNav('product','Product Tab')" :disabled="disableTab('Product Tab')">
                        Products 
                    </button>
                    <button :class="navButtonClass('vendor')" @click="checkNav('vendor','Vendor Tab')" :disabled="disableTab('Vendor Tab')">
                        Vendors 
                    </button>
                    <button :class="navButtonClass('transactions')" @click="checkNav('transactions','Transactions Tab')" :disabled="disableTab('Transactions Tab')">
                        Transactions 
                    </button>
                    <button :class="navButtonClass('inventory')" @click="checkNav('inventory','Inventory Tab')" :disabled="disableTab('Inventory Tab')">
                        Inventory 
                    </button>
                    <button :class="navButtonClass('library')" @click="checkNav('library','Library Tab')" :disabled="disableTab('Library Tab')" v-if="showLibrary">
                        Equipment 
                    </button>
                </div>
                <p v-if="isInventoryBelowTarget && showInvAlert" class="redtext">You have reached a re-order level on at least one product. Go to Inventory/At Reorder Level to view them</p>
                
                <div class="horizFlexCenter" v-if="HeaderOpenCloseMessageString!=null">
                    <p  class="orangetext">{{ HeaderOpenCloseMessageString }}</p>
                    <button class="babybutton" @click="HeaderOpenCloseMessageString=null">OK</button>
                    
                </div >
                <div class="horizFlexCenter" v-if="depositSlipData!=null">
                    <linkbutton ref="depositsliplinkbutton"  v-print="'#depositslipdatadiv'" toplabel="Click to Print the Deposit Slip" class="margin10"/>
                </div>
                <div class="horizFlexCenter" v-if="depositSlipData!=null">
                    
                    <div hidden>
                        <div  class="depositslipclass" id="depositslipdatadiv" v-if="depositSlipData!=null" >
                            <label >{{depositSlipData}}</label>
                        </div>
                    </div>
                    
                    <!-- <a :href="depositSlipUrl" target="_blank" ref="inventoryreportlink">Click to view or print the Deposit Summary </a> -->
                </div>
                
            </div>
            
            
            <!-- <button :class="navButtonClass('wallet')" @click="selectNav('wallet')">Wallets</button> -->
            <!-- <button :class="navButtonClass('explorer')" @click="selectNav('explorer')">Transactions</button>
            
            <button :class="navButtonClass('report')" @click="selectNav('report')">Reports</button>
            <button :class="navButtonClass('admin')" @click="selectNav('admin')">Admin</button> -->
        </div>  
     
        <div class="userArea vertFlex rightjustified" v-if="loggedIn && showHeader">
            <p class="userlabel bold">{{loggedInUser.name}}</p>
            <p class="userlabel" v-if="loggedInUser.isAdmin">ADMIN</p>       
            <linkbutton @click="logout()" toplabel="Logout" />
            <!-- <updatepassword :isAdminChangePassword="false"   :username="username" /> --> 
        </div>
        <securityoverride ref="override"  @overridesuccessful="overrideSuccessful"/>
    </header>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import linkbutton from './controls/linkbutton.vue'
import securityhelper from '../services/securityhelper.js'
import securityoverride from './actions/securityoverride.vue'
// import updatepassword from './actions/updatepassword.vue'
import datamethods from '../services/datamethods'
import inventoryservice from '../services/inventoryservice.js'
import print from 'vue3-print-nb'
import Linkbutton from './controls/linkbutton.vue'
export default {
    name: "navheader",
    components:{
        linkbutton,
       securityoverride
    },
    mixins:[datamethods,securityhelper,inventoryservice],
    directives:{
        print
    },
    data() {
        return {
            // schoolLogoFilePath:'./../' + window.SCHOOL_LOGO,
            schoolname:window.SCHOOL_NAME,
            savedCurrentNav:null
        };
    },
    computed:{
        ...mapFields([
            'currentNav',
            'loggedIn',
            'loggedInUser',
            'lastRefreshDateTime',
            'username',
            'oldpassword',
            'logoOverride',
            'imageBasePath',
            'showHeader',
            'isInventoryBelowTarget',
            'HeaderOpenCloseMessageString',
            'depositSlipUrl',
            'depositSlipData'

        ]),
        schoolLogoFilePath(){
            
                return './../' + window.SCHOOL_LOGO
            

        },
        showInvAlert(){
            if(window.SHOW_INVENTORY_LEVEL_ALERT==undefined){return false}
            else{return window.SHOW_INVENTORY_LEVEL_ALERT}
        },
        showOpenClose(){
            if(window.SHOW_OPEN_CLOSE==undefined){return true}
            else{return window.SHOW_OPEN_CLOSE}
        },
        useAppSecurity(){
            if(window.USE_APP_SECURITY==undefined){return false}
            else{return window.USE_APP_SECURITY}
        },
        showLibrary(){
            
            if(window.SHOW_LIBRARY==undefined){return false}
            else{return window.SHOW_LIBRARY}
        }
    },
    methods:{
        //for new app security
        disableTab(name){
            return this.useAppSecurity && !this.canAccess(name)
        },
        checkNav(name,securityname){
            //check for app security
            if (!this.useAppSecurity){this.selectNav(name); return;}

            this.savedCurrentNav=name //stash this so we can go to it after it works
            if(this.canAccess_allowOverride('POSAdmin',securityname)){
                //console.log('already has access')
                this.selectNav(name)
            }
            
        },
        selectNav(name){
            this.depositSlipData=null
            this.currentNav=name;
            if(window.SHOW_INVENTORY_LEVEL_ALERT){ this.getInventoryBelowTarget(-1)}
            
        },
        overrideSuccessful(){
            //console.log('override!!! call success function')
            this.selectNav(this.savedCurrentNav)
        },
        navButtonClass(name){
            if(this.currentNav==name){
                return "selectedNav"
            }else{
                return "unselectedNav"
            }
        },
        logout(){
            this.loggedIn=false;
            this.$emit('logout')
        },
        /* async getImageBasePath(){
            //call api
            var response = await this.callAPI_Image(null,'imagepath')
            //handle response
            if(response.Successful){
                this.imageBasePath = response.StringResponse
            }else{
                this.responseMessage = response.Message
            }
        }, */
    },
    mounted(){
        //this.getImageBasePath();
    }
}
</script>

<style>
header{
    grid-area:header;
    padding:10px 20px 10px 10px;
    display:grid;
    grid-template-columns:1fr 4fr 1fr;
    grid-template-rows:auto;
    grid-template-areas: 
        "logo nav user";
    font-size:medium;
    background-color:var(--header-color);
}
.logo{
    max-width: 100%;
    max-height:75px;
}
.navArea{
    padding:0px;
    margin:0px;
}
.selectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: 4px solid var(--highlight-button-color);
    border-radius:2px;
    width:125px;
    height:50px;
    padding:0px;
    font-size: medium;
     margin:5px;

}
.unselectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: none;
    border-radius:2px;
    width:125px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:5px;
}
.schoolname{
    font-size:large;
    text-align: center;
    margin:0px 0px 0px 20px;
}
.userlabel{
   
    margin:0px 0px 10px 0px;
    
}
.userArea{
  grid-area:user;
}
.modeImage{
    height:25px;
    margin:5px;
}
.buttoninside{
  display:flex;
  flex-direction: column;
  margin:0px;
    padding:0px;
}
.buttonlabel{
    margin:0px;
}
.babybutton{
    height:20px;
    margin:15px;
}
.depositslipclass{
margin-top:40px;
  white-space: pre-wrap;
  
} 
.noheight{
    height: 0px;
}
</style>